export default {
  dropOrClick: 'Drop files or',
  dropHere: 'Drop files here',
  browse: 'browse',
  uploading: 'Uploading... %{progress}%',
  uploadSuccess: '%{count} file(s) uploaded successfully',
  uploadFailed: 'Failed to upload attachment(s)',
  tooManyFiles: 'Maximum %{max} files allowed per upload',
  fileTooLarge: '%{name}: File too large (max 25MB)',
  invalidFileType: '%{name}: Unsupported file type',
  error: {
    11: 'File exceeds maximum allowed size',
    12: 'File type is not supported',
    13: 'Too many files uploaded',
    14: 'No files provided'
  },
  confirm: {
    title: 'Upload Evidence',
    message: 'Are you sure you want to upload the following file(s)? This action cannot be undone.',
    ok: 'Upload',
    cancel: 'Cancel'
  },
  retry: 'Retry Upload',
  downloadAll: 'Download all files'
};
